// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_container__gYIA4 {
    z-index: 10001;
    padding: .65rem 1.25rem ;
    font-size: 1rem;
    font-weight: 400;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.button_primary__2dQBm {
    background-color: #0D6EFD;
    color: #ffffff;
}

.button_primary__2dQBm:active {
    background-color: #0A58CA;
    color: #ffffff;
}

.button_secondary__NdRAh {
    background-color: #6B747C;
    color: #ffffff;
}

.button_secondary__NdRAh:active {
    background-color: #4E555B;
    color: #ffffff;
}

.button_success__Ix67g {
    background-color: #198754;
    color: #ffffff;
}

.button_success__Ix67g:active {
    background-color: #157347;
    color: #ffffff;
}

.button_warning__5O0WK {
    background-color: #FFC107;
    color: #000000;
}

.button_warning__5O0WK:active {
    background-color: #D39E00;
    color: #000000;
}

.button_danger__jCOXk {
    background-color: #DC3545;
    color: #ffffff;
}

.button_danger__jCOXk:active {
    background-color: #B02A37;
    color: #ffffff;
}

.button_info__qau19 {
    background-color: #0DCAF0;
    color: #ffffff;
}

.button_info__qau19:active {
    background-color: #0B8AB8;
    color: #ffffff;
}

.button_light__gcEm0 {
    background-color: #F8F9FA;
    color: #000000;
}

.button_light__gcEm0:active {
    background-color: #DDE0E3;
    color: #000000;
}

.button_dark__3Xvau {
    background-color: #212529;
    color: #ffffff;
}

.button_dark__3Xvau:active {
    background-color: #1A2026;
    color: #ffffff;
}

.button_link__Ul4G7 {
    background-color: transparent;
    color: #0D6EFD;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0) !important;
}

.button_link__Ul4G7:active {
    background-color: transparent;
    color: #0A58CA;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/button/button.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,iDAAiD;AACrD","sourcesContent":[".container {\n    z-index: 10001;\n    padding: .65rem 1.25rem ;\n    font-size: 1rem;\n    font-weight: 400;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n    cursor: pointer;\n    user-select: none;\n}\n\n.primary {\n    background-color: #0D6EFD;\n    color: #ffffff;\n}\n\n.primary:active {\n    background-color: #0A58CA;\n    color: #ffffff;\n}\n\n.secondary {\n    background-color: #6B747C;\n    color: #ffffff;\n}\n\n.secondary:active {\n    background-color: #4E555B;\n    color: #ffffff;\n}\n\n.success {\n    background-color: #198754;\n    color: #ffffff;\n}\n\n.success:active {\n    background-color: #157347;\n    color: #ffffff;\n}\n\n.warning {\n    background-color: #FFC107;\n    color: #000000;\n}\n\n.warning:active {\n    background-color: #D39E00;\n    color: #000000;\n}\n\n.danger {\n    background-color: #DC3545;\n    color: #ffffff;\n}\n\n.danger:active {\n    background-color: #B02A37;\n    color: #ffffff;\n}\n\n.info {\n    background-color: #0DCAF0;\n    color: #ffffff;\n}\n\n.info:active {\n    background-color: #0B8AB8;\n    color: #ffffff;\n}\n\n.light {\n    background-color: #F8F9FA;\n    color: #000000;\n}\n\n.light:active {\n    background-color: #DDE0E3;\n    color: #000000;\n}\n\n.dark {\n    background-color: #212529;\n    color: #ffffff;\n}\n\n.dark:active {\n    background-color: #1A2026;\n    color: #ffffff;\n}\n\n.link {\n    background-color: transparent;\n    color: #0D6EFD;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0) !important;\n}\n\n.link:active {\n    background-color: transparent;\n    color: #0A58CA;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `button_container__gYIA4`,
	"primary": `button_primary__2dQBm`,
	"secondary": `button_secondary__NdRAh`,
	"success": `button_success__Ix67g`,
	"warning": `button_warning__5O0WK`,
	"danger": `button_danger__jCOXk`,
	"info": `button_info__qau19`,
	"light": `button_light__gcEm0`,
	"dark": `button_dark__3Xvau`,
	"link": `button_link__Ul4G7`
};
export default ___CSS_LOADER_EXPORT___;
